module.exports = __webpack_public_path__ + "images/d072978.jpg";